import axios from "axios";
import store from "../store";
import { Message, Loading } from "element-ui";
import navigateTo from "@/utils/navigate";
import qs from "qs";

let baseURL = null;
let baseURL_FYB = null;
let baseURL_GPT = null;
let baseURL_WSS = null;
const hostname = location.hostname;
if (hostname == "pcn.fangmao.com") {
  baseURL = "https://pcnapi.fangmao.com"; //正式
  baseURL_FYB = "https://fybapi.fangmao.com"; //房易宝正式
  baseURL_GPT = "https://smartchoiceapi.fangmao.com"; //chat gpt正式
  baseURL_WSS = "wss://smartchoiceapi.fangmao.com";
} else if (['test.pcn.fangmao.com"', "101.37.129.89"].includes(hostname)) {
  baseURL = "http://101.37.129.89:30010"; //测试
  // baseURL = "http://47.99.186.69:30050"; // 开发
  // baseURL = "https://pcnapi.fangmao.com"; //正式

  baseURL_GPT = "http://101.37.129.89:30020"; //chat gpt
  baseURL_WSS = "ws://101.37.129.89:30021";

  // baseURL_FYB = "http://47.99.186.69:30052"; // 房易宝开发
  // baseURL_FYB = "https://fybapi.fangmao.com"; //房易宝正式
  baseURL_FYB = "http://101.37.129.89:30071"; //房易宝测试
} else {
  baseURL = "http://192.168.100.4:18071"; // 刘毅
  // baseURL = "http://10.150.9.201:5010"; // 张黎明
  // baseURL = "http://47.99.186.69:30050"; // 开发
  // baseURL = "http://101.37.129.89:30010"; //测试
  baseURL = "https://pcnapi.fangmao.com"; // 正式

  // baseURL_GPT = "http://10.150.9.201:8080"; // 张黎明
  // baseURL_GPT = "http://10.150.9.203:8080"; // 刘毅
  baseURL_GPT = "http://101.37.129.89:30020"; //chat gpt
  // baseURL_GPT = "https://smartchoiceapi.fangmao.com"; //chat gpt正式

  // baseURL_FYB = "http://47.99.186.69:30052"; // 房易宝开发
  // baseURL_FYB = "http://10.150.9.201:18071"; // 张黎明房易宝开发
  // baseURL_FYB = "http://10.150.9.203:18071"; // 刘毅房易宝开发
  baseURL_FYB = "https://fybapi.fangmao.com"; //房易宝正式
  // baseURL_FYB = "http://101.37.129.89:30071"; //房易宝测试

  // baseURL_WSS = "ws://10.150.9.201:10010";
  // baseURL_WSS = "ws://10.150.9.203:10010";
  baseURL_WSS = "ws://101.37.129.89:30021";
  // baseURL_WSS = "wss://smartchoiceapi.fangmao.com";
}

window.baseURL = baseURL;

export { baseURL, baseURL_WSS };

const service = axios.create({
  baseURL,
  timeout: 1 * 60 * 1000,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "X-Requested-With,Content-Type",
    "Access-Control-Allow-Methods": "PUT,POST,GET,DELETE,OPTIONS"
  }
});

service.defaults.withCredentials = true;

let loading = null;
let loadingTimer = null;
let logoutTimer = null;
let messageTimer = null;
const startLoading = () => {
  loading = Loading.service({
    lock: true,
    background: "rgba(0, 0, 0, 0.7)",
    // 判断菜单是否折叠来控制loading的左边距
    customClass: `fm-global-loading ${
      document
        .querySelector(".fm-menu")
        ?.className.includes("el-menu--collapse")
        ? "left60"
        : "left230"
    }`
  });
};

//请求开始
service.interceptors.request.use(
  config => {
    let { token, userId } = store.state.user;
    const { site, userInfo } = store.state.settings;
    const chatLoginInfo = userInfo.chatLoginInfo;

    // 如果使用房易宝api
    if (config.isFybApi) {
      config.baseURL = baseURL_FYB;
    }
    // 使用AI的api
    if (config.isGptApi && chatLoginInfo) {
      config.baseURL = baseURL_GPT;
      token = chatLoginInfo.token;
    }
    let tokenMap = {};
    config.data = config.data || {};
    // 是否有token
    if (token && token !== "undefined" && typeof token !== "undefined") {
      tokenMap = {
        token,
        userId,
        siteId: site?.id || 0
      };
    }
    // 使用AI的api
    if (config.isGptApi && chatLoginInfo) {
      tokenMap.thirdApplicationId = chatLoginInfo.applicationIdentity;
    }
    if (config.header) {
      Object.assign(tokenMap, config.header);
    }
    Object.assign(config.headers, tokenMap);
    const requestMethod = config.method.toLocaleLowerCase();
    if (requestMethod == "post" || requestMethod == "delete") {
      if (Object.prototype.toString.call(config.data) !== "[object FormData]") {
        config.params = config.params || {};
        Object.assign(config.data, tokenMap);
        config.params.siteId = site?.id || 0;
        for (const key in config.params) {
          if (Array.isArray(config.params[key])) {
            config.params[key] = config.params[key].toString();
          }
        }
      }
      if (config.data.dataType == "formData") {
        //如果需要上传文件
        const formData = new FormData();
        for (const key in config.data) {
          if (Array.isArray(config.data[key])) {
            //如果是一个文件数组
            for (const item of config.data[key]) {
              formData.append(key, item);
            }
          } else {
            formData.append(key, config.data[key]);
          }
        }
        config.data = formData;
      }
    } else if (requestMethod == "get") {
      config.params = config.params || config.data || {};
      config.paramsSerializer =
        config.paramsSerializer ||
        function(params) {
          return qs.stringify(params, { arrayFormat: "repeat" });
        };
      config.params.siteId = (site && site.id) || 0;
      for (const key in config.params) {
        //如果value是空，就删除对应key
        const val = config.params[key];
        if (!val && val !== 0 && val !== false) {
          delete config.params[key];
        }
      }
    }
    if (config.data.showLoading !== false && config.showLoading !== false) {
      clearTimeout(loadingTimer); //loading定时器，请求超过100毫秒再显示
      loadingTimer = setTimeout(startLoading, 100);
    }
    return config;
  },
  error => {
    Message.error(error.toString());
    return false;
  }
);

//请求完成
service.interceptors.response.use(
  response => {
    const { showErrorMessage = true } = response.config;
    const res = response.data;
    try {
      //清除loading定时器
      clearTimeout(loadingTimer);
      loading.close();
    } catch (err) {
      // console.log(err);
    }
    // 文件下载类型
    if (["blob", "arraybuffer"].includes(response.config.responseType)) {
      // 如果返回的是json对象 证明报错了 blob转json
      if (response.data.type === "application/json") {
        const reader = new FileReader();
        reader.readAsText(response.data, "utf-8");
        reader.onload = function() {
          const { message, errorMessage } = JSON.parse(reader.result);
          showErrorMessage && Message.warning(message || errorMessage);
        };
        return showErrorMessage ? false : res;
        // 否则返回原始数据
      } else {
        return response;
      }
    }
    if (res.code === 0) {
      return res.data === null ? {} : res.data;
    } else if (res.code == "10010003" || res.message == "请重新登陆") {
      //session过期 重新登录
      // 设置登陆过期
      if (window.TIMEOVER) {
        return false;
      }
      window.TIMEOVER = true;
      if (showErrorMessage) {
        clearTimeout(messageTimer);
        messageTimer = setTimeout(() => {
          Message.warning("登陆过期，请重新登录");
        }, 300);
      }
      clearTimeout(logoutTimer);
      logoutTimer = setTimeout(() => {
        store.dispatch("user/logout");
        navigateTo("/login");
      }, 1000);
      return showErrorMessage ? false : res;
    } else {
      showErrorMessage && Message.error(res.message || res.errorMessage);
      return showErrorMessage ? false : res;
    }
  },
  error => {
    console.log(error);
    clearTimeout(messageTimer);
    if (error.message !== "取消请求") {
      messageTimer = setTimeout(() => {
        Message.error("网络响应错误");
      }, 500);
    }
    try {
      clearTimeout(loadingTimer);
      loading?.close();
    } catch (err) {
      console.log(err);
    }
    return false;
  }
);

function request(data) {
  if (!data.method) {
    data.method = "post";
  }
  return service(data);
}
export default request;
